import { TAG_TYPES } from '../../../../Shared/constants/commonConstants';
import { DETAILED_BOOKING_IMP_FIELDS } from '../constants/DetailedBookingConstants';
import {
  DetailedBookingIMPData, DetailedBookingIMPMainFormFieldErrors
} from '../interface/DetailedBookingInterface';
import { Option } from '../interface/FormFieldInterfaces';
import { COMMON_FIELD_ID_ARRAY, COMMON_FIELD_IDS } from './detailedFormFieldsConfig';

export const createDetailedBookingIMPFormConfig = (
  formData: DetailedBookingIMPData,
  handleInputChange: (field: string, value: string) => void,
  fieldErrors: DetailedBookingIMPMainFormFieldErrors,
  slotPackageOptions: Option[] = [],
  hideCommonFields: boolean = false
) => {
  const allFields = [
    {
      id: COMMON_FIELD_IDS.ENTRY_NUMBER_FIELD,
      type: TAG_TYPES.INPUT_TAG_TYPE,
      label: 'entry-number-label',
      value: formData.entryNumber,
      placeholder: 'entry-number-placeholder',
      disabled: true,
      error: fieldErrors.entryNumber,
    },
    {
      id: COMMON_FIELD_IDS.BRAND_FIELD,
      type: TAG_TYPES.INPUT_TAG_TYPE,
      label: 'brand-label',
      value: formData.brand,
      placeholder: 'brand-placeholder',
      disabled: true,
      error: '',
    },
    {
      id: COMMON_FIELD_IDS.AE_NAME_FIELD,
      type: TAG_TYPES.INPUT_TAG_TYPE,
      label: 'ae-name-label',
      value: formData.aeName,
      placeholder: 'ae-name-placeholder',
      disabled: true,
      error: '',
    },
    {
      id: COMMON_FIELD_IDS.CATEGORY_FIELD,
      type: TAG_TYPES.INPUT_TAG_TYPE,
      label: 'category-label',
      value: formData.category,
      placeholder: 'category-placeholder',
      disabled: true,
      error: '',
    },
    {
      id: COMMON_FIELD_IDS.TYPE_OF_PURCHASE_FIELD,
      type: TAG_TYPES.INPUT_TAG_TYPE,
      label: 'type-of-purchase-label',
      value: formData.typeOfPurchase,
      placeholder: 'type-of-purchase-placeholder',
      disabled: true,
      error: '',
    },
    {
      id: 'slot-for-gp-field',
      type: TAG_TYPES.DROPDOWN_TAG_TYPE,
      label: 'slot-for-gp-label',
      value: formData.slotForGP,
      onChange: (value: string) =>
        handleInputChange(DETAILED_BOOKING_IMP_FIELDS.SLOT_FOR_GP, value),
      placeholder: 'slot-for-gp-placeholder',
      options: slotPackageOptions,
      error: fieldErrors.slotForGP,
    },
    ...(formData.slotForGP
      ? [
        {
          id: 'value-blocked-field',
          type: TAG_TYPES.INPUT_TAG_TYPE,
          label: 'value-blocked-label',
          value: !formData.valueBlockedByLineItem ? 0 : formData.valueBlockedByLineItem.toString(),
          onChange: (value: string) =>
            handleInputChange(
              DETAILED_BOOKING_IMP_FIELDS.VALUE_BLOCKED_BY_LINE_ITEM,
              value
            ),
          placeholder: 'value-blocked-placeholder',
          disabled: true,
          error: fieldErrors.valueBlockedByLineItem,
        },
      ]
      : []),
  ];

  // this is use to prevent the rendering of common form fields inside the accordian ie.: entry number
  if (hideCommonFields) return allFields.filter((field) => !COMMON_FIELD_ID_ARRAY.includes(field.id));

  return allFields;
};
